import {compareDesc, parseISO} from 'date-fns';

import type {BusinessCaseTimelineEvent} from '@prompt-bridge/shared/ai-assistant-core';

export const compareBusinessCaseTimelineEventsNewestFirst = (
  left: BusinessCaseTimelineEvent,
  right: BusinessCaseTimelineEvent
) =>
  compareDesc(parseISO(left.occurredAt), parseISO(right.occurredAt)) ||
  left.id.localeCompare(right.id);
